/**
 * @generated SignedSource<<0dc8f42503f3067568a3eec8b70bbb9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cpaId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorCommProgramAppCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateCpAppTPayload",
        "kind": "LinkedField",
        "name": "createCpAppT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CpAppT",
            "kind": "LinkedField",
            "name": "cpAppT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VendorCommProgramAppCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateCpAppTPayload",
        "kind": "LinkedField",
        "name": "createCpAppT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CpAppT",
            "kind": "LinkedField",
            "name": "cpAppT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8a9826496a92687c70afd129005711ca",
    "id": null,
    "metadata": {},
    "name": "VendorCommProgramAppCreateMutation",
    "operationKind": "mutation",
    "text": "mutation VendorCommProgramAppCreateMutation(\n  $input: CreateCpAppTInput!\n) {\n  createCpAppT(input: $input) {\n    cpAppT {\n      cpaId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "28e0b5228ffe46c675c41cb006efc66e";

module.exports = node;
